import useTranslation from 'next-translate/useTranslation'

import FansiMark from '@/atoms/FansiMark'

import { PageHeroProps } from '../ts'

function Heading({ kind }: PageHeroProps) {
  const { t } = useTranslation('global')

  const title = t(kind)
  const caption = t(`fansi_desc.${kind}`)

  return (
    <div className="flex flex-col flex-shrink-0 space-y-4">
      <h1 className="text-3xl font-medium md:text-4xl 2xl:text-5xl">{title}</h1>
      <FansiMark kind={kind} />
      <p className="text-sm leading-[22px] md:text-base max-w-sm">{caption}</p>
    </div>
  )
}

export default Heading
